export const SET_LOGIN_CODE_OPTIONS = 'GetLoginCodeOptions';
export const SET_SEND_CODE_RESULT = 'SetSendCodeResult';
export const SET_VALIDATE_LOGIN_CODE_RESULT = 'SetValidateLoginCodeResult';
export const SET_REMEMBER_DEVICE = 'SetRememberDevice';
export const SET_SEND_RESET_PASSWORD_LINK_RESULT =
	'SetSendResetPasswordLinkResult';
export const SET_VALIDATE_PASSWORD_RESET_CODE_RESULT =
	'SetValidatePasswordResetCodeResult';
export const SET_RESET_PASSWORD_RESULT = 'SetResetPasswordResult';
